// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_so-5";
export var filledCircle = "_so-4";
export var historyEntry = "_so-3";
export var messageSideLeft = "_so-1";
export var messageSideRight = "_so-2";
export var orderTrackingCarouselWrapper = "_so-6";
export var orderTrackingInfoContainer = "_so-0";